import { AxiosInstance } from '@service/axios-instance';

export type TidStatus = {
    tid: number;
    operation: string | null;
    machine_id: string | null;
    apelido: string | null;
    sector: string | null;
    last_heartbeat_time: number | null;
    ccid: string | null;
};

export async function getAllTidsStatus(): Promise<TidStatus[]> {
    const res = await AxiosInstance.get('/admin/all_tids_status', {
        withCredentials: true
    });
    return res.data;
}
